import React from "react";
import Header from "../../Layout/Header";

const Section1 = () => {
  return (
    <div
      className="w-full relative bg-no-repeat bg-center  bg-cover font-Artemus "
      style={{ backgroundImage: "url('/assets/bg/bg.gif')" }}
    >
      <Header />
      <div className=" bg-black/50 relative">
        <div className="flex justify-center items-center relative">
        <video
              autoPlay
              muted
              loop
              playsInline
              className=" w-screen object-cover h-[600px]"
            >
               <source src="/assets/bg/Stablix Hero Video.mp4" type="video/mp4" />
            </video>
          <div className="w-[45%] mx-auto absolute left-0 right-0 top-0 bg-black/30 "></div>
        </div>

        <div className="absolute top-0 w-full left-0 right-0 max-w-9xl mx-auto py-10">
          <div className="w-[95%] mx-auto text-white lg:pt-20">
            <p className="w-full text-center md:text-4xl text-2xl font-bold font-Artemus">
            Your Gateway to Seamless, Fast, and Cost-Effective Stablecoin Transfers
            </p>
            <p
              style={{ textShadow: " 2px 2px 5px #FFFFFF " }}
              className="mt-2 text-sm md:text-lg tracking-wider font-montserrat w-full text-center"
            >
            Simplify the way you manage and trade stablecoins. 
            Built on Avalanche Subnet for unmatched efficiency.
            </p>
            <div className="text-[#010010] font-montserrat font-bold mt-10 flex justify-center items-center gap-5 sm:gap-10">
              <button
                style={{
                  background:
                    "radial-gradient(43.07% 43.07% at 46.75% 50.94%, #FFFAD1 26.4%, #856E4F 100%)",
                }}
                className="text-sm rounded-xl px-5 py-2 "
              >
                Connect Wallet
              </button>
              <button
                style={{
                  background:
                    "radial-gradient(43.07% 43.07% at 46.75% 50.94%, #FFFAD1 26.4%, #856E4F 100%)",
                }}
                className="text-sm rounded-xl px-5 py-2 "
              >
              Make a Transfer
              </button>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  );
};

export default Section1;